angular
  .module('admin')

  .factory('AccountManagerIdCache', function() {
    let cache;

    return {
      get: () => cache,
      set: value => (cache = value)
    };
  });
